import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useStore, useTheme } from "@/comn/hooks";
import React, { useEffect } from "react";
import { APIS, SF_AUTH_SRCH, SG_SCRH_AUTH_LIST } from "../../ptl/usrauth/services/OsciOgaAuthService";

/*
 * Pop-up for OGA User Auth Registration
 * !== OGA 사용자 권한 등록을 위한 팝업  ==!
 */
export const OSCI0103018Q = (props: any): JSX.Element => {
    /*
     * [2026-10-28] fixedAuthId 추가.
     * 값이 있으면 그 권한 한 건만 조회한다(관리자 권한 포함). 값이 없으면 기존과 동일하게
     * 관리자 권한을 제외한 목록을 조회한다. 이 팝업은 0103012S·0103016S·0103022S 가 공유하므로
     * 넘기지 않는 화면의 동작은 바뀌지 않는다.
     */
    const { tin, ogaUsrAuthList, callback, fixedAuthId } = props;

    const modal = useModal();
    const { theme } = useTheme();
    const { pgeUid } = usePage({ pgeUid: "osci0103018q" });
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    const form = {
        authSrch: useForm({
            defaultSchema: SF_AUTH_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const grid = {
        authList: useGrid({
            defaultSchema: SG_SCRH_AUTH_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getAuthList: useFetch({
            api: (page = grid.authList.page, size = grid.authList.size) =>
                // [2026-10-28] fixedAuthId 를 넘기면 서버가 해당 권한 한 건만 조회한다.
                APIS.getAuthList(tin, { ...form.authSrch.getValues(), fixedAuthId }, page, size),
            enabled: true,
            key: [grid.authList.page, grid.authList.size],
            onSuccess: () => {},
            onError: () => modal.openModal({ content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onBtnApplyClick: () => {
            if (grid.authList.getChecked().length === 0) {
                modal.openModal({ content: "msg.osc.00084" }); // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            if (callback) callback(grid.authList.getChecked());
        },
        onBtnSrchClick: () => fetch.getAuthList.fetch(),
    };

    const render = {
        checkbox: (row: any) =>
            row.isRgsrYn !== "Y" && ogaUsrAuthList.findIndex((item: any) => item.authId === row.authId) === -1,
    };

    useEffect(() => {
        form.authSrch.setValue("tin", tin);
    }, [theme]);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section gap={2}>
                        <Group.Row>
                            <Group.Control {...form.authSrch.schema.authId} />
                            <Group.Control {...form.authSrch.schema.authNm} />
                        </Group.Row>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onBtnSrchClick} />
                        </Layout.Right>
                    </Group.Section>

                    <Group.Section gap={2}>
                        <Grid {...grid.authList.grid} data={fetch.getAuthList.data?.authList} render={render} />

                        <Layout.Right>
                            <Button role={"apply"} onClick={handler.onBtnApplyClick} />
                        </Layout.Right>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
